<script>
import { mapState } from 'vuex'
import NavigationList from './navigation-drawer/NavigationList'
import Rating from './Rating'

import { logOut } from '@/auth'

import { Plugins } from '@capacitor/core'
const { Browser } = Plugins

export default {
  name: 'NavigationDrawer',
  components: { NavigationList, Rating },
  props: {
    user: { type: Object, default: () => null }
  },
  data() {
    return {
      drawer: null,
      bottomNav: true
    }
  },
  computed: {
    ...mapState({
      authenticated: state => state.user.authenticated,
      profileCompleted: state => state.user.profileCompleted
    }),
    fullName() {
      const { firstName, lastName } = this.user || {}
      return this.$isBuyer ? `${firstName} ${lastName}` : firstName
    },
    items() {
      return {
        buyer: [
          {
            title: 'Menu',
            icon: '$vuetify.icons.utensils',
            route: '/'
          },
          {
            title: 'Orders',
            icon: '$vuetify.icons.receipt',
            route: '/orders'
          },
          {
            title: 'Payment',
            icon: '$vuetify.icons.wallet',
            route: '/payment'
          },
          {
            title: 'Promotions',
            icon: '$vuetify.icons.tag',
            route: '/promotions',
            visible: this.profileCompleted || this.$isSeller
          },
          {
            title: 'Sell on Pona',
            icon: '$vuetify.icons.store',
            action: this.openSeller
          }
        ],
        seller: [
          {
            title: 'Orders',
            icon: '$vuetify.icons.receipt',
            route: '/seller/orders'
          },
          { title: 'Menu', icon: '$vuetify.icons.utensils', route: '/menu' },
          {
            title: 'Schedule',
            icon: '$vuetify.icons.clock',
            route: '/schedule'
          },
          {
            title: 'Payouts',
            icon: '$vuetify.icons.wallet',
            route: '/payouts'
          }
        ],
        bottom: [
          {
            title: 'Settings',
            icon: '$vuetify.icons.cog',
            route: '/settings',
            visible: this.profileCompleted || this.$isSeller
          },
          {
            title: 'Help',
            icon: '$vuetify.icons.lifeRing',
            action: this.openHelp
          },
          {
            title: 'Sign out',
            icon: '$vuetify.icons.signOut',
            action: this.signOut,
            visible: this.authenticated
          }
        ]
      }
    }
  },
  methods: {
    // Pluralize words
    pluralize(string, count) {
      return count > 1 ? `${string}s` : string
    },

    openSeller() {
      Browser.open({ url: 'https://www.pona.app/seller' })
    },

    openHelp() {
      Browser.open({ url: 'https://www.pona.app/faq' })
    },

    // Sign out user
    signOut() {
      this.$store.dispatch('user/logOut')
      this.$router.replace('/sign-out')
    }
  }
}
</script>

<template>
  <div
    v-if="!['LoginView', 'ProfileOnboardingView'].includes($route.name)"
    class="nav-drawer"
  >
    <v-navigation-drawer v-model="drawer" width="320" overlay-opacity="0.8" app>
      <div class="py-6">
        <div v-if="profileCompleted || $isSeller">
          <v-list two-line class="px-3">
            <v-img
              v-if="$isBuyer"
              src="@/assets/logo.svg"
              class="drawer-logo"
            />

            <v-list-item>
              <v-list-item-avatar v-if="$isSeller" class="mr-1">
                <router-link to="/settings" class="user-name">
                  <v-avatar color="grey lighten-3">
                    <v-img
                      v-if="user && user.avatar"
                      :src="user.avatar"
                      :lazy-src="user.avatar"
                    />

                    <v-icon v-else class="black--text">
                      $vuetify.icons.camera
                    </v-icon>
                  </v-avatar>
                </router-link>
              </v-list-item-avatar>

              <v-list-item-content class="ml-3">
                <router-link to="/settings" class="user-name">
                  <v-list-item-title class="font-weight-bold">
                    {{ fullName }}
                  </v-list-item-title>
                </router-link>

                <!-- Seller rating -->
                <v-list-item-subtitle
                  v-if="$isSeller && user && user.sellerRating"
                  class="d-flex align-center"
                >
                  <Rating :rating="user.sellerRating || 0" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider />
        </div>

        <div v-if="$isBuyer">
          <navigation-list :items="items.buyer" />
          <v-divider />
        </div>

        <div v-if="$isSeller">
          <navigation-list :items="items.seller" />
          <v-divider />
        </div>

        <div>
          <navigation-list :items="items.bottom" />
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<style lang="sass" scoped>

.drawer-logo
  width: 60px
  height: 60px
  position: absolute
  right: 15px
  top: 15px

.drawer-bio
  margin-top: 40px

.user-name
  text-decoration: none
  color: #000

/* View grid */
.drawer-grid
  height: 80%
  display: grid
  grid-template-rows: auto auto
  grid-template-areas: "top" "bottom"
  .v-toolbar
    grid-area: toolbar
  .content-top
    padding: 16px
    grid-area: top
  .content-bottom
    padding: 20px
    grid-area: bottom
    align-self: end
</style>
